import styled from 'styled-components'

export const StyledCardsWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
  justify-content: space-between;
  gap: 32px;
  width: 100%;

  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textTertiary};

  .card {
    background: white;
    border: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
    box-sizing: border-box;
    border-radius: 12px;
  }

  ${({ theme }) => theme.media.sm`
    flex-flow: column nowrap;
    gap: 16px;
    font-size: 13px;
    margin-bottom: 48px;
  `}
`

export const StyledTimerWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 24px 32px;

  .countdown-title {
    align-self: flex-start;
  }

  .trade-mining-clock {
    margin: 48px 0 19px;
  }

  .currentPeriod {
    align-self: flex-end;
  }

  ${({ theme }) => theme.media.sm`
    padding: 16px 24px 24px;

    .countdown-title {
      order: 0;
    }

    .trade-mining-clock {
      order: 2;
      margin: 0;
    }

    .currentPeriod {
      order: 1;
      align-self: flex-start;
      margin: 24px 0 12px;
    }
  `}
`

export const StyledReportWrapper = styled.div`
  flex: 0 0 calc(50% - 16px);
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  padding: 24px 32px 32px;

  .lastPeriod {
    position: absolute;
    right: 32px;
    bottom: 24px;
  }

  ${({ theme }) => theme.media.sm`
    padding: 16px 24px 32px;
    
    .lastPeriod {
      left: 24px;
      right: auto;
      top: 69.5px;
      bottom: auto;
    }
  `}
`

export const StyledReportIcon = styled.img`
  width: 24px;
  height: 24px;
`

export const StyledReportHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;

  a {
    font-size: 17px;
    font-weight: 500;
    line-height: 27px;
    color: #5f55a9;
  }

  ${({ theme }) => theme.media.sm`
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 29px;

    a {
      align-self: flex-end;
      font-size: 13px;
    }
  `}
`

export const StyledReportContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 22px;
  margin-top: 32px;
`

export const StyledReportItem = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  .label {
    width: 95px;
    margin: 0 20px 0 16px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(95, 85, 169, 0.85);
  }

  .value {
    margin-left: 24px;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(95, 77, 188, 0.85);
  }

  .report-divider {
    height: 16px;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }

  ${({ theme }) => theme.media.sm`
    .label {
      width: 90px;
      font-size: 13px;
    }

    .value {
      margin-left: 16px;
      font-size: 17px;
    }
  `}
`

export const StyledReportCalcIcon = styled.img`
  width: 16px;
  height: 16px;

  ${({ theme }) => theme.media.sm`
    width: 12px;
    height: 12px;
  `}
`

export const StyledReportCalcItem = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
  margin-left: 24px;
  font-size: 15px;
  font-weight: 400;
  line-height: 15px;
  color: ${({ theme }) => theme.colors.textTertiary};

  ${({ theme }) => theme.media.sm`
    gap: 4px;
    font-size: 12px;
  `}
`
